export default __webpack_public_path__ + "static/media/single-03-bathroom-inactive.7d9093fc.webp";